import { RootState } from "@/store";
import { Controllers } from "@infoland/iprova-api";
import { ActionTree, Dispatch, GetterTree, Module, MutationTree } from "vuex";

export interface TimeZone {
    display_name: string;
    id: string;
}

interface TimeZonesState {
    timeZones: TimeZone[];
}

function initialize(): TimeZonesState {
    return {
        timeZones: null
    };
}

// initial state
const state: TimeZonesState = initialize();

const mutations: MutationTree<TimeZonesState> = {
    timeZones(state: TimeZonesState, timeZones: TimeZone[]): void {
        state.timeZones = timeZones;
    }
};

const actions: ActionTree<TimeZonesState, RootState> = {
    async getTimeZones({ commit, state }): Promise<TimeZone[]> {
        //load timeZones from API and update state if not already exists
        let timeZones = state.timeZones;
        if (timeZones == null) {
            timeZones = await Controllers.GenericController.getAsync<TimeZone[]>(`time_zones`);

            //update store
            commit("timeZones", timeZones);
        }
        return timeZones;
    }
};

// export the namespace
export const namespace = "timeZones";

// export the store 'module'
export default <Module<TimeZonesState, RootState>>{
    namespaced: true,
    state,
    mutations,
    actions
};
